import React from 'react';
import axios from 'axios';
import { Container } from 'react-grid-system';

// STYLES
import styled from 'styled-components';
import Colors from '../../shared/colors';
import './subscription.component.css';

// SHARED
import {Section} from '../../shared/shared';

// ICONS
import FaFacebook from 'react-icons/lib/fa/facebook'
import FaTwitter from 'react-icons/lib/fa/twitter'
import TiSocialInstagram from 'react-icons/lib/ti/social-instagram'

// COMPONENTS
import Title from '../../components/title/title.component';
import Subtitle from '../../components/subtitle/subtitle.component';

export default class Subscription extends React.Component{
    constructor(props) {
        super();
        this.state = {value: '', error: false, msg: '', valid: false, btnDisable: false};
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        this.setState({value: event.target.value});
    }

    handleSubmit(event) {
        var methodCall = 'addSubscriber';
        var listID = 27;
        var apikey = '25618cdbaa40f63868fe4458dbbc5485924fd646';

        var URL =   "https://api.e-goi.com/v2/rest.php?type=json";
        URL     +=  "&method=" + methodCall;
        URL     +=  "&functionOptions[listID]=" + listID;
        URL     +=  "&functionOptions[apikey]=" + apikey;
        URL     +=  "&functionOptions[lang]=" + localStorage.getItem('i18next_Lng').toString();
        URL     +=  "&functionOptions[email]=" + this.state.value;
        
        if (this.state.value.length <= 3) {
            let msg = this.props.t('Insira um email válido.');
            this.setState({error: true, msg: msg})
            event.preventDefault();
            return false;
        }
        else {
            this.setState({btnDisable: true})
            axios.get(URL)
                .then(res => {
                    if (res.data.Egoi_Api.addSubscriber.ERROR === 'DATA_CANNOT_BE_EDITED') {
                        let msg = this.props.t('Já está inscrito na nossa newsletter.');
                        this.setState({error: true, msg: msg})
                        return false;
                    } else if (res.data.Egoi_Api.addSubscriber.ERROR === 'INVALID_EMAIL_VALIDATION'){
                        let msg = this.props.t('Verifique se inseriu o email corretamente.');
                        this.setState({error: true, msg: msg})
                        return false;
                    } else if (res.data.Egoi_Api.addSubscriber.ERROR === 'EMAIL_ADDRESS_INVALID') {
                        let msg = this.props.t('Verifique se inseriu o email corretamente.');
                        this.setState({error: true, msg: msg})
                        return false;
                    } else if (res.data.Egoi_Api.addSubscriber.CONFIRM_EMAIL || res.data.Egoi_Api.addSubscriber.UID) {
                        let msg = this.props.t('Obrigado. Foi-lhe enviado um email de confirmação da subscrição.');
                        this.setState({error: false, msg: msg, valid: true, btnDisable: true})
                            setTimeout(() => {
                                this.setState({valid: false, btnDisable: false});
                            }, 5000);
                        return false;
                    } else if(res.data.Egoi_Api.addSubscriber.ERROR && res.data.Egoi_Api.addSubscriber.ERROR.length > 0) {
                        let msg = this.props.t('Ocorreu um erro. Tente novamente!');
                        this.setState({error: true, msg: msg})
                        return false;
                    }
                }
            );
        }
        event.preventDefault();
        return false;
    }

    render () {
        let t =  this.props.t;
        return (
            <Section className="backgroundColor sectionPadding">
                <Container>
                    <Title text={t('Saiba sempre de tudo em primeira mão')}/>
                    <Subtitle text={t('Acompanhe o desenvolvimento deste projeto através da nossa newsletter')} color={Colors.text.secondary}/>

                    <Form>
                        <form onSubmit={this.handleSubmit}>
                            <input className="inputSubscription" type="email" placeholder={t('Insira o seu email')} value={this.state.value} onChange={this.handleChange}/>
                            <input className="buttonSubscription" type="submit" value={t('Submeter')} disabled={this.state.btnDisable}/>
                            {this.state.error && <MessageError>{this.state.msg}</MessageError>}
                            {this.state.valid && <MessageValid>{this.state.msg}</MessageValid>}
                        </form>
                    </Form>

                    <Contacts>
                        <span>{t('Telefone')}: </span>
                        (+351) 21 352 70 60
                    </Contacts>

                    <Contacts>
                        <span>{t('Email')}: </span>
                        <a href="mailto:tasteportugal@ahresp.com" target="_blank"  rel="noopener noreferrer">tasteportugal@ahresp.com</a>
                    </Contacts>

                    <SocialIcons>
                        <a href="https://www.facebook.com/tasteportugal.ahresp/" target="_blank"  rel="noopener noreferrer"><FaFacebook/></a>
                        <a href="https://twitter.com/TasteAhresp" target="_blank"  rel="noopener noreferrer"><FaTwitter/></a>
                        <a href="https://www.instagram.com/tasteportugal.ahresp/" target="_blank"  rel="noopener noreferrer"><TiSocialInstagram/></a>
                    </SocialIcons>

                </Container>
            </Section>
        )
    }
}

const Form = styled.div`
    text-align: center;
    margin-bottom: 50px;
    margin-top: 50px;
`

const Contacts = styled.div `
    margin-bottom: 10px;
    text-align: center;
    font-size: 14px;
    color: hsl(0, 0%, 17%);
    span {
        font-weight: 600;
        color: hsl(0, 0%, 17%);
        font-family: "PT Sans";
    }
    a{
        color: ${Colors.primary}
    }
`
const SocialIcons = styled.div `
    display: flex;
    align-items:center;
    justify-content: center;
    font-size:28px;
    margin-top: 50px;
    font-family: "PT Sans";

    a{
        color: #ADAEAF;
        transition: all 0.3s ease;
    }

    a:nth-child(2){
        margin-left: 15px;
        margin-right: 15px;
    }

    a:hover{
        color: #11837B;
    }
`
const MessageError = styled.div `
    margin-top: 10px;
    font-size: 13px;
    font-weight: 600;
    color: red;
    transition: all 0.3s ease;
    font-family: "PT Sans";
`
const MessageValid = styled.div `
    margin-top: 10px;
    font-size: 13px;
    font-weight: 600;
    color: green;
    transition: all 0.3s ease;
    font-family: "PT Sans";
`


// WEBPACK FOOTER //
// ./src/components/subscription/subscription.component.js